<template>
  <div class="rule-item">
    <div class="rule-header-wrapper">
      <div class="rule-header">
        <span class="required" v-if="isMandatory">*</span>
        <span class="label">行驶区域</span>
        <i class="el-icon-delete delete-btn" @click="emit('remove')" v-if="!isMandatory"></i>
      </div>
      <div class="desc">承租人超出限定区域行驶，需支付违约金。</div>
    </div>
    <div class="ai-box" v-if="tip">
      <span class="ai-tag">AI</span>
        <span class="ai-text">{{ tip }}</span>
    </div>
    <div class="rule-body">
      <el-form-item :prop="`${propPrefix}.limit`" :rules="requiredRule" style="margin-bottom: 0;">
        <el-radio-group :value="modelValue.limit" @input="handleAreaLimitChange">
          <el-radio :label="0">不限制</el-radio>
          <el-radio :label="1">限定区域</el-radio>
        </el-radio-group>
      </el-form-item>
      <div class="indent-block" v-if="modelValue.limit === 1">
        <el-form-item :prop="`${propPrefix}.limitArea`" :rules="modelValue.limit === 1 ? requiredRule : []">
          <el-input
            :value="modelValue.limitArea"
            @input="updateField('limitArea', $event)"
            type="textarea"
            :rows="4"
            placeholder="请输入"
            maxlength="200"
            show-word-limit
            style="width: 400px;">
          </el-input>
        </el-form-item>
        <div class="flex-row">
          <span class="label-text">超出区域行驶按违约处理，违约金</span>
          <el-form-item :prop="`${propPrefix}.fee`" :rules="modelValue.limit === 1 ? getRules(10000) : []" class="flex-input single" style="margin-bottom: 0;">
            <el-input
                :value="modelValue.fee"
                placeholder="请输入"
                size="small"
                v-number:float
                @input="updateField('fee', $event)">
                <template slot="append">元/次</template>
            </el-input>
          </el-form-item>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { requiredRule, getRules } from './utils'

const props = defineProps({
  modelValue: {
    type: Object,
    required: true,
  },
  propPrefix: {
    type: String,
    required: true,
  },
  tip: {
    type: String,
    default: '',
  },
  isMandatory: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['update:modelValue', 'remove'])

const updateField = (key, value) => {
  const newItem = { ...props.modelValue, [key]: value }
  emit('update:modelValue', newItem)
}

const handleAreaLimitChange = (val) => {
  if (val === 0) {
    const newItem = { ...props.modelValue, limit: val, limitArea: '', fee: '' }
    emit('update:modelValue', newItem)
  } else {
    updateField('limit', val)
  }
}
</script>

<style lang="scss" scoped>
@import './rules.scss';
.label-text {
  margin-right: 8px;
}
</style>
